import { PosDataLevel } from '@/domain/models/Pos';

export const posProviderNameToJa = (name: string): string => {
  switch (name) {
    case 'Toshiba TEC':
      return '東芝テック';
    default:
      return name;
  }
};

// NOTE 本来であればDBにある全てのproviderのidをオブジェクトで羅列するべきだが、随時追加をされているものでバックエンドとの連携コストがかかる。
// 条件指定の必要なidだけを
export const PROVIDER = {
  TERAOKA_SEIKOU_POS: 10,
};

export interface PosProvider {
  pos_provider_id: number;
  pos_provider_name: string;
  pos_data_level: PosDataLevel;
}
